module.exports = __webpack_public_path__ + "img/blueDownArrow.67e7609b.svg";